export default __webpack_public_path__ + "assets/models/4596247d8fb2bb21b12741eaa155979a.glb";